import Storage from '../lib/storage';
import { prepareData, displayStatusMessage } from '../helpers/notes-and-favorites';
import { sleep } from '../lib/sleep';
import { IS_DISABLED } from '../constants';

let currentLink: HTMLAnchorElement | null;

const attachNoteEventsModal = (e: Event): void => {
    const elm = e.target;
    const isSubmitFromModal = elm && elm instanceof HTMLButtonElement && elm.classList.contains('js-add-note-from-modal');
    const isCurrentLink = elm && elm instanceof HTMLAnchorElement && elm.classList.contains('js-add-note-modal');

    if (isCurrentLink) {
        currentLink = elm;
    }

    if (isSubmitFromModal) {
        const form = elm.closest('form');

        if (!form) {
            return;
        }

        onFormSubmit(elm, form, currentLink);
    }
};

const onFormSubmit = async (noteSubmitButton: HTMLButtonElement, form: HTMLFormElement, addNoteElement: HTMLAnchorElement | null): Promise<void> => {
    let running = false;

    if (running) {
        return;
    }

    const chathostID: string | undefined = form.dataset.id;
    const action: string | undefined = form.dataset.action;
    const chathostNick: string | undefined = form.dataset.name;
    const noteInputElement: HTMLTextAreaElement | null = form.querySelector('.js-note-input');
    const note: string | undefined = noteInputElement?.value.trim();
    const noteWrapper: HTMLElement | null | undefined = addNoteElement?.closest('.js-note-wrapper');

    if (chathostID && action && chathostNick) {
        running = true;

        noteInputElement?.setAttribute('disabled', 'disabled');
        noteInputElement?.classList.add(IS_DISABLED);
        noteSubmitButton.setAttribute('disabled', 'disabled');
        noteSubmitButton.classList.add(IS_DISABLED);

        const requestStatus: boolean = await prepareData(chathostID, action, { note: note });

        if (note && note.length > 0) {
            addNoteElement?.classList.add('has-content');
        } else {
            addNoteElement?.classList.remove('has-content');
        }

        setNoteContent(noteWrapper, note);

        await sleep(500);

        noteInputElement?.removeAttribute('disabled');
        noteInputElement?.classList.remove(IS_DISABLED);
        noteSubmitButton.removeAttribute('disabled');
        noteSubmitButton.classList.remove(IS_DISABLED);

        closeModal();
        displayStatusMessage({
            chathost: chathostNick,
            action: action,
            status: requestStatus,
        });

        running = false;
    }
};

const setNoteContent = (noteWrapper: HTMLElement | null | undefined, note: string | undefined): void => {
    const noteInline: HTMLElement | null | undefined = noteWrapper?.querySelector('.js-add-note-inline');
    const noteOriginalInput: HTMLTextAreaElement | null | undefined = noteWrapper?.querySelector('.js-note-input');
    const NOTE_ORIGINAL_CONTENT = 'Click here to add a memo';

    if (noteInline) {
        noteInline.innerHTML = note ? note : NOTE_ORIGINAL_CONTENT;
    }

    if (noteOriginalInput) {
        noteOriginalInput.innerHTML = note ? note : '';
    }
};

const setShowNoteAfterLogin = (addNoteNotLoggedIn: HTMLElement | null, storage: Storage): void => {
    addNoteNotLoggedIn?.addEventListener('click', () => {
        storage.set('showNotesAfterLogin', true);
    });
};

const showNoteModalAfterLogin = (storage: Storage): void => {
    const addNoteElement: HTMLAnchorElement | null = document.querySelector('.js-add-note-modal');
    addNoteElement?.click();
    storage.delete('showNotesAfterLogin');

    Analytics.sendEvent({
        category: 'Profile',
        action: 'Note',
        label: 'Guest logged in',
    });
};

const closeModal = (): void => {
    const modalClose: HTMLAnchorElement | null = document.querySelector('.js--modal__close');

    if (modalClose) {
        modalClose.click();
    }
};

const attachNoteEvents = () => {
    const storage: Storage = new Storage('notes');
    const isShowNoteAfterLogin: boolean = storage.get('showNotesAfterLogin');
    const addNoteNotLoggedIn: HTMLDivElement | null = document.querySelector('.js-add-note-set');

    setShowNoteAfterLogin(addNoteNotLoggedIn, storage);

    if (isShowNoteAfterLogin) {
        showNoteModalAfterLogin(storage);
    }

    document.addEventListener('click', (e: Event) => {
        attachNoteEventsModal(e);
    });
};

attachNoteEvents();
